import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faSearch, faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Col, Form, Row, Toast } from 'react-bootstrap';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import swal from 'sweetalert';
import { lookerParams } from '../../../../../shared/lookerParams';
import { setAnalyticsLookerAction, setRiskTypeAction } from './../../../../../stores/actions/lookerActions';
import reportFiltersService from './reportFiltersService';
import './ReportFiltersStyle.scss';

class ReportFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            showToast: false,
            defualtFilter: {
                categoryId: null,
                categoryName: 'All',
                max: 10,
                min: 0,
                isSelected: false,
                riskScore: {
                    min: 0,
                    max: 10,
                },
            },
            api: {
                response: {
                    status: '',
                    message: '',
                },
            },
            fieldRiskType: null,
            riskTypes: [],
            riskScoreFilters: [],
            riskScoreReadmittance: [],
            riskScoreAdherence: null,
            lookerParams: lookerParams,
        };
        this.reportFiltersService = new reportFiltersService();
        this.createSliderElement = this.createSliderElement.bind(this);
        this.setFilterValue = this.setFilterValue.bind(this);
        this.handleRiskTypeChange = this.handleRiskTypeChange.bind(this);
        this.handleOnChangeSelect = this.handleOnChangeSelect.bind(this);
    }

    /**
     * Create slider elements
     */
    createSliderElement(index, elemProperties) {
        let colWidth = this.props.boxClasses;
        let elem = (
            <div className={colWidth}>
                <Col>
                    <Form.Group controlId={elemProperties.categoryId}>
                        <Row>
                            <Form.Check
                                type="checkbox"
                                name={elemProperties.categoryId}
                                value={elemProperties.isSelected}
                                onChange={this.handleOnChangeSelect}
                                checked={elemProperties.isSelected}
                                className="col-1 checkbox"
                                sm={1}
                                md={1}
                                lg={1}
                            />
                            <Form.Label className="element-label col-11" column sm={6} md={6} lg={4}>
                                {elemProperties.categoryName}
                            </Form.Label>
                            <Col className="col-12" sm={4} md={4} lg={6}>
                                <InputRange
                                    maxValue={elemProperties.max}
                                    minValue={elemProperties.min}
                                    value={elemProperties.riskScore}
                                    onChange={(value) => this.setFilterValue(index + 1, value)}
                                />
                            </Col>
                        </Row>
                    </Form.Group>
                </Col>
            </div>
        );
        return elem;
    }

    /**
     * Set filter score values on change
     * @param index index value
     * @param value value which is modified
     */
    setFilterValue = (index, value) => {
        const { defualtFilter, riskScoreReadmittance } = this.state;
        if (index) {
            riskScoreReadmittance[index - 1].riskScore = value;
            this.setState({
                riskScoreReadmittance: riskScoreReadmittance,
            });
        } else {
            riskScoreReadmittance.forEach((element) => {
                element.riskScore = value;
            });
            this.setState({
                riskScoreReadmittance: riskScoreReadmittance,
                defualtFilter: {
                    categoryId: defualtFilter.categoryId,
                    categoryName: defualtFilter.categoryName,
                    min: defualtFilter.min,
                    max: defualtFilter.max,
                    riskScore: value,
                },
            });
        }
    };

    setAdherenceValue = (value) => {
        const { riskScoreAdherence } = this.state;
        if (riskScoreAdherence) {
            riskScoreAdherence.riskScore = value;
            this.setState({
                riskScoreAdherence: riskScoreAdherence,
            });
        }
    };

    /**
     * Get default filter
     */
    getDefaultFilter(isSelected = false) {
        let colWidth = this.props.boxClasses;
        const { defualtFilter } = this.state;
        let defualtEleent = (
            <div className={colWidth}>
                <Col>
                    <Form.Group controlId={defualtFilter.categoryId}>
                        <Row>
                            <Form.Check
                                name={defualtFilter.categoryId}
                                type="checkbox"
                                className="col-1 checkbox"
                                value={defualtFilter.isSelected}
                                onChange={this.handleOnChangeSelect}
                                checked={isSelected}
                                sm={1}
                                md={1}
                                lg={1}
                            />
                            <Form.Label className="element-label col-11" column sm={6} md={6} lg={4}>
                                {defualtFilter.categoryName}
                            </Form.Label>
                            <Col className="col-12" sm={4} md={4} lg={6}>
                                <InputRange
                                    maxValue={defualtFilter.max}
                                    minValue={defualtFilter.min}
                                    value={defualtFilter.riskScore}
                                    onChange={(value) => this.setFilterValue(null, value)}
                                />
                            </Col>
                        </Row>
                    </Form.Group>
                </Col>
            </div>
        );
        return defualtEleent;
    }

    /**
     * Load adherence slider elements
     */
    loadAdherenceSlider = (elements) => {
        let elem = (
            <Col>
                <Form.Group controlId="adherance1">
                    <Row>
                        <Col className="col-12" sm={4} md={4} lg={6}>
                            <InputRange
                                maxValue={elements.max}
                                minValue={elements.min}
                                value={elements.riskScore}
                                onChange={(value) => this.setAdherenceValue(value)}
                            />
                        </Col>
                    </Row>
                </Form.Group>
            </Col>
        );
        return elem;
    };

    /** Field risk type change event
     * @param {event} e - Element event data.
     */
    handleRiskTypeChange(event) {
        const value = +event.target.value;
        const name = event.target.name;
        this.setState({
            [name]: value,
        });
        this.props.setRiskType(this.getRiskType(value));
    }

    /**
     * Handle on check box change
     * @param event event
     */
    handleOnChangeSelect = (event) => {
        const { defualtFilter, riskScoreReadmittance } = this.state;
        if (event.target.checked) {
            if (event.target.name) {
                if (riskScoreReadmittance.length) {
                    const index = riskScoreReadmittance.findIndex((item) => item.categoryId === +event.target.name);
                    riskScoreReadmittance[index].isSelected = event.target.checked;
                    this.setState({
                        riskScoreReadmittance: riskScoreReadmittance,
                    });
                }
            } else {
                if (riskScoreReadmittance.length) {
                    riskScoreReadmittance.forEach((element) => {
                        element.isSelected = event.target.checked;
                    });
                    this.setState({
                        riskScoreReadmittance: riskScoreReadmittance,
                        defualtFilter: {
                            categoryId: defualtFilter.categoryId,
                            categoryName: defualtFilter.categoryName,
                            min: defualtFilter.min,
                            max: defualtFilter.max,
                            riskScore: defualtFilter.riskScore,
                        },
                    });
                }
            }
        } else {
            if (event.target.name) {
                const index = riskScoreReadmittance.findIndex((item) => item.categoryId === +event.target.name);
                if (riskScoreReadmittance.length) {
                    riskScoreReadmittance[index].isSelected = event.target.checked;
                    this.setState({
                        riskScoreReadmittance: riskScoreReadmittance,
                    });
                }
            } else {
                if (riskScoreReadmittance.length) {
                    riskScoreReadmittance.forEach((element) => {
                        element.isSelected = event.target.checked;
                    });
                    this.setState({
                        riskScoreReadmittance: riskScoreReadmittance,
                        defualtFilter: {
                            categoryId: defualtFilter.categoryId,
                            categoryName: defualtFilter.categoryName,
                            min: defualtFilter.min,
                            max: defualtFilter.max,
                            riskScore: defualtFilter.riskScore,
                        },
                    });
                }
            }
        }
    };

    /**
     * Get risk type
     * @param {*} id type id
     */
    getRiskType(id) {
        return this.state.riskTypes.find((item) => item.riskTypeId === id);
    }

    /**
     * Ui elements rendering
     */
    render() {
        const { showToast, api, riskTypes, fieldRiskType, riskScoreReadmittance, riskScoreAdherence } = this.state;
        let leftElements = [];
        let middleElements = [];
        let rightElements = [];
        let adherenceElements = null;

        //Set div sizeas dynamically based on content length
        const arrayLength = riskScoreReadmittance.length;
        const value = arrayLength / 3;
        let pageSize = Math.trunc(value);
        if (value > pageSize) {
            pageSize = pageSize + 1;
        }

        let defualtIsSelected = 0;

        //Set readmittance slider elements in different div
        if (riskScoreReadmittance.length) {
            for (let i = 0; i < pageSize; i++) {
                if (riskScoreReadmittance[i].isSelected) {
                    defualtIsSelected++;
                }
                leftElements.push(this.createSliderElement(i, riskScoreReadmittance[i]));
            }

            for (let j = pageSize; j < 2 * pageSize; j++) {
                if (riskScoreReadmittance[j].isSelected) {
                    defualtIsSelected++;
                }
                middleElements.push(this.createSliderElement(j, riskScoreReadmittance[j]));
            }

            for (let k = 2 * pageSize; k < riskScoreReadmittance.length; k++) {
                if (riskScoreReadmittance[k].isSelected) {
                    defualtIsSelected++;
                }
                rightElements.push(this.createSliderElement(k, riskScoreReadmittance[k]));
            }
            let isSelected = false;
            if (defualtIsSelected === riskScoreReadmittance.length) {
                isSelected = true;
            }

            rightElements.push(this.getDefaultFilter(isSelected));
        }

        //Set Adherence slider element
        if (fieldRiskType) {
            adherenceElements = this.loadAdherenceSlider(riskScoreAdherence);
        }

        return (
            <div className="dummy ">
                <div className="section-head">
                    <p>REPORT FILTERS</p>
                </div>
                <div className="report-filters">
                    <Row className="toast-container">
                        <Col md={12} className="pt-2">
                            <Toast className="toast-container" show={showToast} onClose={this.toggleToast}>
                                <Toast.Header className={` ${api.response.status !== 'Failure' ? 'success' : 'error'}`}>
                                    <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                                    <strong className="mr-auto">{api.response.status}</strong>
                                </Toast.Header>
                                <Toast.Body>{api.response.message}</Toast.Body>
                            </Toast>
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Col sm={12} md={2} lg={1}>
                            <Form.Label className=" model-field-label">Risk Type</Form.Label>
                        </Col>
                        <Col sm={12} md={2} lg={2}>
                            <Form.Control
                                as="select"
                                size="sm"
                                name="fieldRiskType"
                                onChange={this.handleRiskTypeChange}
                                value={fieldRiskType || ''}
                            >
                                {riskTypes.map((key) => (
                                    <option key={key.key} value={key.riskTypeId}>
                                        {key.riskType}
                                    </option>
                                ))}
                                ;
                            </Form.Control>
                        </Col>
                        <Col sm={12} md={2} lg={4} className="middle-div"></Col>
                        <Col sm={12} md={6} lg={5}>
                            <Row className="button-group flex-wrap div-app-btn">
                                <Col className="col-sm-6 col-md-4 col-lg-4 mb-lg-0 mb-2 div-apply-btn">
                                    <Button
                                        id="apply-btn"
                                        className="w-100 m-0 btn-save"
                                        size="md"
                                        onClick={this.applyAnalytics}
                                    >
                                        <FontAwesomeIcon icon={faSearch} />
                                        <span className="ml-3">Apply Filters</span>
                                    </Button>
                                </Col>

                                <Col className="col-sm-6 col-md-4 col-lg-4 mb-lg-0 mb-2 div-reset-btn">
                                    <Button
                                        id="reset-btn"
                                        className="w-100 m-0 btn-delete"
                                        size="md"
                                        onClick={this.resetAnalytics}
                                    >
                                        <FontAwesomeIcon icon={faSync} />
                                        <span className="ml-3">Reset</span>
                                    </Button>
                                </Col>
                                <Col className="col-sm-6 col-md-4 col-lg-4 mb-lg-0 mb-2 div-close-btn">
                                    <Button
                                        id="close-btn"
                                        className="w-100 m-0 btn-close"
                                        size="md"
                                        onClick={this.closeAnalytics}
                                    >
                                        <FontAwesomeIcon icon={faTimesCircle} />
                                        <span className="ml-3">Close</span>
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col sm={12} md={1} lg={1}>
                            <Form.Group className="form-inline" controlId="formHorizontalEmail">
                                <Form.Label className=" model-field-label risk-score-label">Risk Scores</Form.Label>
                            </Form.Group>
                        </Col>
                        {fieldRiskType && fieldRiskType === 1 ? (
                            <Col sm={12} md={11} lg={11} className="mt-3">
                                <Row className="sliders-view">
                                    <Col sm={12} md={4} lg={4}>
                                        <div className="scores left-view">{leftElements}</div>
                                    </Col>
                                    <Col sm={12} md={4} lg={4}>
                                        <div className="scores middle-view">{middleElements}</div>
                                    </Col>
                                    <Col sm={12} md={4} lg={4}>
                                        <div className="scores right-view">{rightElements}</div>
                                    </Col>
                                </Row>
                            </Col>
                        ) : (
                            <Col sm={12} md={11} lg={11}>
                                <Row className="sliders-view">
                                    <Col sm={12} md={4} lg={4}>
                                        <div className="scores-adherence">{adherenceElements}</div>
                                    </Col>
                                </Row>
                            </Col>
                        )}
                    </Row>
                </div>
            </div>
        );
    }

    /**
     * Toggle toast
     */
    toggleToast = () => {
        const { showToast } = this.state;
        this.setState({
            showToast: !showToast,
        });
        setTimeout(() => {
            this.setState({
                showToast: false,
            });
        }, 4000);
    };

    /**
     * Component mounting invoking func
     */
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        const looker = {
            readmittance: null,
            adherence: null,
        };
        this.props.setLookerUpdated(looker);
        this.getReportFilters();
    }

    /**
     * Apply analytics
     */
    applyAnalytics = () => {
        const { fieldRiskType, riskScoreReadmittance, riskScoreAdherence, lookerParams } = this.state;
        let lookerReadmittanceUrl = '';
        let lookerAdherenceUrl = '';
        const param = {
            lookerPath: {
                look:
                    fieldRiskType && fieldRiskType === 1
                        ? lookerParams.lookerPath.readmittanceTable
                        : lookerParams.lookerPath.adherenceTable,
                models: lookerParams.lookerPath.models,
            },
            riskTypeId: fieldRiskType,
            riskType: this.getRiskType(fieldRiskType).key,
            riskScoreFilters: {
                readmittance: riskScoreReadmittance,
                adherence: riskScoreAdherence,
            },
        };

        if (this.props.getLookerUrl && this.props.getLookerUrl.setUrl && this.props.getLookerUrl.setUrl.payload) {
            if (this.props.getLookerUrl.setUrl.payload.adherence) {
                lookerAdherenceUrl = this.props.getLookerUrl.setUrl.payload.adherence;
            }
        }

        if (this.props.getLookerUrl && this.props.getLookerUrl.setUrl && this.props.getLookerUrl.setUrl.payload) {
            if (this.props.getLookerUrl.setUrl.payload.readmittance) {
                lookerReadmittanceUrl = this.props.getLookerUrl.setUrl.payload.readmittance;
            }
        }
        this.reportFiltersService.applyFilters(param).then((res) => {
            if (res && res.status === 'Success') {
                const looker = {
                    readmittance: fieldRiskType && fieldRiskType === 1 ? res.data.lookerPath : lookerReadmittanceUrl,
                    adherence: fieldRiskType && fieldRiskType === 2 ? res.data.lookerPath : lookerAdherenceUrl,
                };
                this.props.setLookerUpdated(looker);
                this.setState({
                    api: {
                        response: {
                            status: res.status,
                            message: res.message,
                        },
                    },
                });
                this.toggleToast();
            }
        });
    };

    /**
     * get model details using modelId and versionId
     */
    getReportFilters(isReset = false) {
        const { defualtFilter } = this.state;

        this.reportFiltersService.getReportFilters().then((res) => {
            if (res.status === 'Success' && res.data) {
                if (isReset) {
                    this.setState({
                        riskTypes: res.data.riskTypes,
                        riskScoreFilters: res.data.riskScoreFilters,
                        riskScoreAdherence: res.data.riskScoreFilters[res.data.riskTypes[0].key],
                        riskScoreReadmittance: res.data.riskScoreFilters[res.data.riskTypes[1].key],
                        defualtFilter: {
                            categoryId: defualtFilter.categoryId,
                            categoryName: defualtFilter.categoryName,
                            min: defualtFilter.min,
                            max: defualtFilter.max,
                            isSelected: false,
                            riskScore: {
                                min: 0,
                                max: 10,
                            },
                        },
                        api: {
                            response: {
                                status: 'Success',
                                message: 'Reset Successfully',
                            },
                        },
                    });
                    const looker = {
                        readmittance: null,
                        adherence: null,
                    };
                    this.props.setLookerUpdated(looker);
                    this.toggleToast();
                } else {
                    this.setState({
                        riskTypes: res.data.riskTypes,
                        riskScoreFilters: res.data.riskScoreFilters,
                        fieldRiskType: res.data.riskTypes[0].riskTypeId,
                        riskScoreAdherence: res.data.riskScoreFilters[res.data.riskTypes[0].key],
                        riskScoreReadmittance: res.data.riskScoreFilters[res.data.riskTypes[1].key],
                    });
                    this.props.setRiskType(res.data.riskTypes[0]);
                }
            }
        });
    }

    /**
     * Reset analytics
     */
    resetAnalytics = () => {
        swal({
            title: 'Are you sure to reset?',
            text: '',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                const isReset = true;
                this.getReportFilters(isReset);
            }
        });
    };

    /**
     * Close user
     */
    closeAnalytics = () => {
        this.props.history.push('/model/list');
    };
}

ReportFilters.propTypes = {
    boxClasses: PropTypes.string,
    setRiskType: PropTypes.func,
    getLookerUrl: PropTypes.shape({
        setUrl: PropTypes.shape({
            payload: PropTypes.shape({
                adherence: PropTypes.string,
                readmittance: PropTypes.string,
            }),
        }),
    }),
};

/**
 * Mapping redux state into props
 */
const MapStateToProps = (state) => {
    return {
        getLookerUrl: state.getAnalyticsLookerUrl,
    };
};

/**
 * Dispatching redux actions
 */
const MapDispatchToProps = (dispatch) => {
    return {
        setLookerUpdated: (params) => dispatch(setAnalyticsLookerAction(params)),
        setRiskType: (params) => dispatch(setRiskTypeAction(params)),
    };
};

ReportFilters.propTypes = {
    setLookerUpdated: PropTypes.func,
    history: PropTypes.object.isRequired,
};

export default connect(MapStateToProps, MapDispatchToProps)(withRouter(ReportFilters));
